'use client';

import React, { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

const HERO_TITLES = [
'Building the Framework for the Future of Construction',
'Your Integrated Platform for a Smarter Build',
'Precision Engineering Meets Architectural Freedom'];


export default function HeroSection() {
  const [titleIndex, setTitleIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setTitleIndex((prev) => (prev + 1) % HERO_TITLES?.length);
        setVisible(true);
      }, 400);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background image with overlay */}
      <div className="absolute inset-0">
        <img
          src="/assets/images/Main_Bending_Factory-1774454334984.png"
          alt="Automated manufacturing facility"
          className="w-full h-full object-cover"
          loading="eager" />
        
        <div className="absolute inset-0 bg-hero-overlay" />
      </div>
      {/* Content */}
      <div className="relative z-10 container mx-auto container-padding text-center pt-24 lg:pt-32">
        <div className="max-w-4xl mx-auto">
          {/* Logo */}
          <img
            src="/assets/images/NeXSYS_logo_-_Copy-1774454634126.png"
            alt="NeXSYS Logo"
            loading="eager"
            className="h-36 sm:h-48 lg:h-60 w-auto mx-auto mb-12" />
          

          {/* Animated heading */}
          <div className="min-h-[8rem] sm:min-h-[10rem] lg:min-h-[12rem] flex items-start justify-center mb-8">
            <h1
              className="text-2xl sm:text-3xl lg:text-hero-lg font-heading font-bold text-white leading-snug px-2"
              style={{
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateY(0)' : 'translateY(-20px)',
                transition: 'opacity 0.4s ease, transform 0.4s ease'
              }}>
              
              {HERO_TITLES?.[titleIndex]}
            </h1>
          </div>

          {/* Description */}
          <p className="text-lg sm:text-xl text-white/80 mb-10 max-w-2xl mx-auto mt-[30px]">
            A revolutionary construction platform combining key stake holders within a NeXSYS
            ecosystem ensuring seamless development. Supporting various modalities for faster,
            smarter, and more sustainable building.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16 lg:mb-24">
            <Link
              href="/products"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap bg-white text-[hsl(161,93%,30%)] hover:bg-white/90 shadow-lg hover:shadow-xl hover:-translate-y-1 font-bold h-14 rounded-lg px-10 text-lg transition-all duration-300">
              
              Explore Products
            </Link>
            <Link
              href="/partners/channel"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap border-2 border-white bg-transparent text-white hover:bg-white/10 font-bold h-14 rounded-lg px-10 text-lg transition-all duration-300">
              
              Partner with Us
            </Link>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2">
          <div className="text-white/60 nexsys-bounce">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="h-8 w-8">
              
              <path d="m6 9 6 6 6-6" />
            </svg>
          </div>
        </div>
      </div>
    </section>);

}